/**
 * Card now lives in the shared design system, @atomic/ui-kit — shared with
 * chomps so a fix lands in both at once. Thin re-export shim: every existing
 * `import { Card, CardHeader, ... } from ".../ui/card"` keeps working unchanged.
 */
export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
} from "@atomic/ui-kit"
